import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "9px",
	height: "11px",
	viewBox: "0 0 9 11",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Rectangle" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Symbols",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Content-card-metrics-/-Standard-photo-post",
				transform: "translate(-150.000000, -1.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-4",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M151,1 L158,1 C158.552285,1 159,1.44771525 159,2 L159,10.8865781 C159,11.1627205 158.776142,11.3865781 158.5,11.3865781 C158.377543,11.3865781 158.259344,11.3416388 158.167818,11.2602827 L154.5,8 L154.5,8 L150.832182,11.2602827 C150.625791,11.4437417 150.309754,11.4251514 150.126295,11.21876 C150.044939,11.1272344 150,11.0090352 150,10.8865781 L150,2 C150,1.44771525 150.447715,1 151,1 Z",
						id: "Rectangle"
					})
				})
			})
		})
	]
});
export default SvgBookmark;
